import { html } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

export const linkTemplate = (
  node: HTMLElement,
) => {
  const link = node as HTMLAnchorElement;
  return html`<one-link href="${link.href}" target="_blank">${unsafeHTML(link.innerHTML)}</one-link>`;
};
